var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PartialView',[(_vm.hasAdmin('EQUIPMENT_STATUSES'))?_c('EquipmentStatuses',{ref:"statuses",staticClass:"admin-content-partial",attrs:{"header-tag":"h3","id":_vm.statusId,"route-params":{view: 'statuses'},"show-back":false},on:{"update:statuses":_vm.handleUpdateStatuses}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }